/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatchUpdateSettingsDto } from '../models/BatchUpdateSettingsDto';
import type { GlobalSettingResponse } from '../models/GlobalSettingResponse';
import type { UpdateSettingDto } from '../models/UpdateSettingDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GlobalSettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all global settings
     * Returns all global settings. Public endpoint.
     * @returns GlobalSettingResponse List of global settings returned successfully.
     * @throws ApiError
     */
    public globalSettingsControllerFindAll(): CancelablePromise<Array<GlobalSettingResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/global-settings',
        });
    }
    /**
     * Batch update global settings
     * Upserts multiple global settings at once. Requires ADMIN role.
     * @returns GlobalSettingResponse Settings updated successfully.
     * @throws ApiError
     */
    public globalSettingsControllerBatchUpdate({
        requestBody,
    }: {
        requestBody: BatchUpdateSettingsDto,
    }): CancelablePromise<Array<GlobalSettingResponse>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/global-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Get a global setting by key
     * Returns a single global setting by its unique key. Public endpoint.
     * @returns GlobalSettingResponse Setting found.
     * @throws ApiError
     */
    public globalSettingsControllerFindByKey({
        key,
    }: {
        /**
         * Unique setting key
         */
        key: string,
    }): CancelablePromise<GlobalSettingResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/global-settings/{key}',
            path: {
                'key': key,
            },
            errors: {
                404: `Setting not found.`,
            },
        });
    }
    /**
     * Update a global setting
     * Upserts a single global setting by key. Requires ADMIN role.
     * @returns GlobalSettingResponse Setting updated successfully.
     * @throws ApiError
     */
    public globalSettingsControllerUpdate({
        key,
        requestBody,
    }: {
        /**
         * Unique setting key
         */
        key: string,
        requestBody: UpdateSettingDto,
    }): CancelablePromise<GlobalSettingResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/global-settings/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
}
